<template>
 <common-dialog
      ref="dialog"
      width="750px"
      :show-save-button="false"
      unit="修改日志"
      id-key="ClassId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="()=>{}"
      :get-data-func="api.list"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
<el-table border size="mini" :data="tableData" style="width: 100%">
          <el-table-column prop="Title" label="修改对象"/>
          <el-table-column prop="BeforeValue" label="修改前数据">
          <template slot-scope="{row}">
              <span v-if="row.FieldName!='CertUrl'">{{row.BeforeValue}}</span>
              <a v-else :href="row.BeforeValue?location.protocol + '//' + location.host+'/api'+row.BeforeValue:'#' " target="_blank">{{row.BeforeValue}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="AfterValue" label="修改后数据">
            <template slot-scope="{row}">
              <span v-if="row.FieldName!='CertUrl'">{{row.AfterValue}}</span>
              <a v-else :href="row.AfterValue?location.protocol + '//' + location.host+'/api'+row.AfterValue:'#' " target="_blank">{{row.AfterValue}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="TeacherName" label="修改人"/>
          <el-table-column prop="CreateTime" label="修改时间"/>
           <slot name="column"></slot>
</el-table>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" size="small" @click="close">关 闭</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";
import list from "@/components/common/list";
export default {
  components: {
    commonDialog,
    list
  },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "学生明细",
    },
  },
  data() {
    return {
      api: require("@/api/gd/log").default,
      data: {
        RecordId:0,
        Remark:""
      },
      main: [],
      ExamNames: "",
      ExamIds: [],
      tableData: [],
      type: null,
      rules:{},
      params: {
         RecordId:0
      },
      location:location
    };
  },
  methods: {
    onOpened(data){
        
    },
    onCreateOpened(row) {
    },

    onEditOpened(type) {
      this.api.list(type).then(res => {
        if(res.Code==0){
            this.tableData=res.Data
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
  .info {
    display: inline-block;
    margin-right: 40px;
  }
}
.examSearch {
  padding-top: 10px;
  margin-bottom: 20px;
}
.detailsTable {
  margin: 20px 0;
}
.examInp {
  width: calc(100% - 70px);
  /deep/ .el-input__inner {
    width: 100%;
  }
}
</style>
